/**
 * This type does not fully match the keys in InvoiceLine interface, as there
 * is a discrepancy in the Zervant backend.
 *
 * At this point the InvoiceLine interface is used with data from a piece of
 * API that provides invoice data to Ageras, while the InvoiceLineColumn type
 * is used with the ZervantSettings service that can provide information on
 * invoice line columns (e.g. visible columns) to be used for displaying.
 *
 * So in general InvoiceLine is for data and InvoiceLineColumn is for settings.
 */

export const InvoiceLineColumnValues = [
  'date',
  'description',
  'discount',
  'discountPct',
  'grossTotal',
  'netTotal',
  'productType',
  'quantity',
  'taxTotal',
  'total',
  'unit',
  'unitPrice',
  'vatPct',
  'work',
] as const

export type InvoiceLineColumn = (typeof InvoiceLineColumnValues)[number]
